
export type RequestRefund200 = {
  amount?: number;
  message?: string;
  refundId?: string;
  status?: string;
  success: boolean;
};
